import React from 'react'

const Dark = () => (
  <svg
    width="124"
    height="18"
    viewBox="0 0 124 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 17.7457H3.5391V12.4136H6.79693C10.3595 12.4136 12.7384 10.1167 12.7384 6.63616V6.61273C12.7384 3.13222 10.3595 0.835327 6.79693 0.835327H0V17.7457ZM5.92974 3.63613C7.9571 3.63613 9.15243 4.70256 9.15243 6.62444V6.64789C9.15243 8.56979 7.9571 9.64792 5.92974 9.64792H3.5391V3.63613H5.92974Z"
      fill="var(--primary)"
    />
    <path
      d="M27.9385 3.56253C28.9698 3.56253 29.7666 2.75392 29.7666 1.78126C29.7666 0.808591 28.9698 0 27.9385 0C26.9072 0 26.1104 0.808591 26.1104 1.78126C26.1104 2.75392 26.9072 3.56253 27.9385 3.56253ZM26.2275 17.7424H29.6495V5.17973H26.2275V17.7424Z"
      fill="var(--primary)"
    />
    <path
      d="M41.0655 18C44.6515 18 46.3859 15.8789 46.7726 14.0273L46.8078 13.8984H43.6671L43.6437 13.9687C43.3976 14.6719 42.5421 15.4453 41.1358 15.4453C39.3897 15.4453 38.2999 14.2734 38.2647 12.2695H46.9132V11.2148C46.9132 7.41788 44.6046 4.92175 40.9249 4.92175C37.2451 4.92175 34.8896 7.47648 34.8896 11.4726V11.4843C34.8896 15.5039 37.2217 18 41.0655 18ZM40.9835 7.47648C42.4015 7.47648 43.421 8.37884 43.6319 10.1132H38.2998C38.5225 8.41399 39.5772 7.47648 40.9835 7.47648Z"
      fill="var(--primary)"
    />
    <path
      d="M72.755 18C76.5519 18 78.9777 15.5625 78.9777 11.4609V11.4375C78.9777 7.37101 76.505 4.92175 72.7432 4.92175C68.9932 4.92175 66.5322 7.39445 66.5322 11.4375V11.4609C66.5322 15.5508 68.9346 18 72.755 18ZM72.7667 15.3164C71.0791 15.3164 70.0127 13.9219 70.0127 11.4609V11.4375C70.0127 9.01165 71.0909 7.60538 72.7432 7.60538C74.4073 7.60538 75.4972 9.01165 75.4972 11.4375V11.4609C75.4972 13.9101 74.4308 15.3164 72.7667 15.3164Z"
      fill="var(--primary)"
    />
    <path
      d="M98.7717 9.37732H79.2129V12.3656H98.7717V9.37732Z"
      fill="var(--primary)"
    />
    <path
      d="M16.8253 0.835327H16.833V7.35101H16.9034C17.5479 5.7924 18.8721 4.9252 20.7589 4.9252C23.4776 4.9252 25.1652 6.82367 25.1652 9.85886V17.7457H21.7433V10.562C21.7433 8.80416 20.8761 7.76118 19.3175 7.76118C17.8057 7.76118 16.833 8.90963 16.833 10.5503V17.7457H13.4111V2.4618L16.8253 0.835327Z"
      fill="var(--primary)"
    />
    <path
      d="M34.2348 0.835327H34.2403V17.7457H30.8184V2.46288L34.2348 0.835327Z"
      fill="var(--primary)"
    />
    <path
      d="M50.8833 5.17957H50.8955V7.28898H50.9659C51.4815 5.85926 52.794 4.92175 54.4815 4.92175C56.2393 4.92175 57.5167 5.85926 57.9386 7.51164H58.0089C58.5714 5.92959 60.0714 4.92175 61.9113 4.92175C64.3722 4.92175 66.0246 6.62099 66.0246 9.15227V17.7422H62.6027V10.0078C62.6027 8.55462 61.8761 7.75773 60.5519 7.75773C59.2511 7.75773 58.3956 8.70697 58.3956 10.1015V17.7422H55.1026V9.90229C55.1026 8.55462 54.3409 7.75773 53.0753 7.75773C51.7745 7.75773 50.8955 8.74212 50.8955 10.1601V17.7422H47.4736V6.80389L50.8833 5.17957Z"
      fill="var(--primary)"
    />
    <path
      d="M102.43 5.17957H102.432V7.2421H102.502C103.147 5.80068 104.436 4.92175 106.334 4.92175C109.1 4.92175 110.67 6.6913 110.67 9.63275V17.7422H107.248V10.3359C107.248 8.69524 106.475 7.75773 104.94 7.75773C103.404 7.75773 102.432 8.88275 102.432 10.5234V17.7422H99.0098V6.80873L102.43 5.17957Z"
      fill="var(--primary)"
    />
    <path
      d="M115.06 5.18104V7.2421H115.13C115.774 5.80068 117.064 4.92175 118.962 4.92175C121.728 4.92175 123.298 6.6913 123.298 9.63275V17.7422H119.876V10.3359C119.876 8.69524 119.103 7.75773 117.567 7.75773C116.032 7.75773 115.06 8.88275 115.06 10.5234V17.7422H111.638V6.8112L115.06 5.18104Z"
      fill="var(--primary)"
    />
  </svg>
)

export default Dark
